export const roundedValue = (value: any) => {
  return Math.ceil(value / 100) * 100;
};
